<div *ngIf="!verticalAlignment" class="buttons-container">
  <div class="secondary-button-container">
    <button
      yat-button
      type="button"
      [id]="secondaryButtonId"
      class="btn secondary-weak"
      [ngClass]="[className ? className : '']"
      (click)="secondaryButtonClick()">
      <span>{{ secondaryButtonName }}</span>
    </button>
  </div>
  <div class="primary-button-container">
    <ng-container *ngIf="useYatAutoSpinner; else buttonWithoutSpinner">
      <button
        yat-button
        type="submit"
        class="btn"
        [id]="primaryButtonId"
        [ngClass]="[className ? className : '', negativePrimaryButton ? 'primary destructive' : 'primary']"
        [disabled]="disablePrimaryButton"
        (click)="primaryButtonClick()"
        [yatAutoSpinner]="useYatAutoSpinner === true ? '' : useYatAutoSpinner"
        [asyncForm]="asyncForm"
        [matomoClickCategory]="matomoEventCategory ?? ''"
        [matomoClickAction]="matomoEventClickPrimaryButtonAction ?? ''"
        [matomoClickName]="matomoEventName ?? ''">
        <span>{{ primaryButtonName }}</span>
        <yat-icon id="55a43be0-366a-40fa-9948-648fa802ee98" *ngIf="primaryButtonSuffixIcon" [name]="primaryButtonSuffixIcon"></yat-icon>
      </button>
    </ng-container>
    <ng-template #buttonWithoutSpinner>
      <button
        yat-button
        type="submit"
        class="btn"
        [id]="primaryButtonId"
        [ngClass]="[className ? className : '', negativePrimaryButton ? 'primary destructive' : 'primary']"
        [disabled]="disablePrimaryButton"
        (click)="primaryButtonClick()"
        [matomoClickCategory]="matomoEventCategory ?? ''"
        [matomoClickAction]="matomoEventClickPrimaryButtonAction ?? ''"
        [matomoClickName]="matomoEventName ?? ''">
        <span>{{ primaryButtonName }}</span>
        <yat-icon id="a177ad56-655c-47a3-b545-03174aa94ced" *ngIf="primaryButtonSuffixIcon" [name]="primaryButtonSuffixIcon"></yat-icon>
      </button>
    </ng-template>
  </div>
</div>
<div *ngIf="verticalAlignment" class="buttons-container-vertical">
  <button
    yat-button
    class="btn primary w-100 mbottom-12"
    [ngClass]="[className ? className : '']"
    type="button"
    (click)="primaryButtonClick()"
    [disabled]="disablePrimaryButton"
    [matomoClickCategory]="matomoEventCategory ?? ''"
    [matomoClickAction]="matomoEventClickPrimaryButtonAction ?? ''"
    [matomoClickName]="matomoEventName ?? ''">
    <span>{{ primaryButtonName }}</span>
  </button>
  <div class="cancel-button-container w-100">
    <a
      yat-link
      class="link link-secondary"
      [ngClass]="[className ? className : '']"
      (click)="secondaryButtonClick()"
      [matomoClickCategory]="matomoEventCategory ?? ''"
      [matomoClickAction]="matomoEventClickPrimaryButtonAction ?? ''"
      [matomoClickName]="matomoEventName ?? ''"
      ><span>{{ secondaryButtonName }}</span></a
    >
  </div>
</div>
